import Vue from 'vue';
import { compile } from '../plugins/handlebars';

const methods = {
  $push: (array, element) => {
    Vue.set(array, array.length, element);
  },
  dateFormat: value => (value ? new Date(value).toISOString().substr(0, 10) : value),
  handlebars: (template = '', model = {}, options = {}) => {
    try {
      return compile(template, {
        ...options,
        noEscape: true,
      })(model);
    } catch (error) {
      return new Error(`حدثت مشكلة أثناء تحديث الصياغة\nوصف المشكلة: ${error}`);
    }
  },
};

Vue.mixin({
  methods: methods,
});
// extend formFieldType with compactAttachment after taqadhi-ui is loaded
Vue.mixin({
  beforeCreate() {
    // only extend once when formFieldType is available
    if (this.$root === this && this.formFieldType && !this.formFieldType.compactAttachment) {
      Vue.set(this.formFieldType, 'compactAttachment', 25);
    }
  },
});

export default methods;
